module.exports = __webpack_public_path__ + "img/logo.898019e1.png";